export default {
	login: {
		aside: {
			title: "Simplify and Securely Manage Your Bank Accounts",
			subTitle:
				"Take control of your finances effortlessly with our user-friendly web application ensuring complete security for your peace of mind.",
		},
		authCard: {
			title: "Log in",
			info: {
				about: "We will send you a code to confirm your email.",
				privacy: "Privacy policy"
			},
			continueBtn: "Continue",
			wordSeparator: "or continue with",
			email: {
				title: "Email",
				placeholder: "Email",
			},
			oAuthButtons: {
				facebook: {
					alt: "Facebook icon",
					btn: "Continue with Facebook",
					icon: "src/assets/facebook_icon.svg",
				},
				google: {
					alt: "Google icon",
					btn: "Continue with Google",
					icon: "../src/assets/google_icon.svg",
				},
				apple: {
					alt: "Apple icon",
					btn: "Continue with Apple",
					icon: "../src/assets/apple_icon.svg",
				},
			},
		},
		emailCode: {
			title: "Email code",
			description: "Enter the code sent by email. It may take a few seconds to send. Also, remember to check your spam folder.",
			loader: "Loading",
			sendButtonCode: {
				question: "Send back email ? ",
				send: "Send",
			},
			success: 'Code successfully send',
			error: 'Something wrong happened, please try again or contact us'
		},
		phoneNumberStep: {
			title: "SMS code",
			description: "Enter code send by SMS",
			sendButtonCode: {
				question: "Send back SMS ? ",
				send: "Send",
			},
			codeMessageError: {
				title: "Error",
				message:
					"An error occurred with the entered code. Please enter the right code",
			},
		},
		mail: {
			empty: "Enter mail address",
			wrongFormat: "Wrong format mail.",
		},
		template: {
			question: "Not registered ?",
			signIn: "Login",
		},
	},
	apiErrors: {
		"ERR_NETWORK": "Network error",
		"general_server_error": "Internal error.",
		"general_argument_invalid": "Invalid email.",
		"bank_account_already_exists": "Bank account name already exists.",
		"user_phone_not_found": "No phone number is associated with this account.",
		"user_oauth2_bad_request": "Bad request.",
		"user_jwt_invalid": "Oops! An error occurred.",
		"user_invalid_code": "The code is incorrect.",
		"user_invalid_token": "Invalid code.",
		"user_session_already_exists": "A session is already active.",
		"user_unauthorized": "You are not authorized to do this.",
		"user_oauth2_unauthorized": "The access provider does not authorize you to do this.",
		"user_not_found": "User not found.",
		"user_session_not_found": "The current session is not found.",
		"user_already_exists": "The user already exists.",
		"user_email_already_exists": "This email address already exists.",
		"user_blocked": "Your account was deleted. Please, contact us.",
		"general_rate_limit_exceeded": "Rate limit for the account has been exceeded. Please try again 1 hour.",
		"general_access_forbidden": "You are not authorized to access this page.",
		"general_unauthorized_scope": "You need to be connected to access to this page.",
		"error/bad-request": "Verify the format of provided values.",
		"error/internal-error":
			"Oops, an internal error has occurred. Please contact us.",
		"auth/email-wrong-format": "The email format is incorrect.",
		"auth/internal-error": "Oups.. Something wrong happened we can't authenticate you for now, please try again or contact us",
	},
	loader: {
		content: 'Loading, it may takes some times',
	},
	badgeDemoContent: 'Data demo',
	demoBanner: {
		title: 'Demo mode on',
		descriptionBold: 'Explore all the features',
		description: 'with secure sample data. Disable to see your real data',
		btnRefresh: 'New data',
		btn: 'Turn off demo mode',
	},
	pageTitle: {
    isTyping: "Typing...",
    isSaving: "Saving...",
    saved: "Saved !",
    inputPlaceholder: "Enter the new name...",
    hint: "💡 Enter the new account name, it will be saved automatically",
    saveError: "Error while saving",
  },
	alertBanner: {
		title: "Missing informations",
		description: "Please make sure to fill in your name on",
		link: "Settings",
	},
	responsiveDrawer: {
		createAccount: {
			title: "Create account",
			description: "When you create your account, we never access your bank details. The accounts are only available on this app to simulate or manage your budget.",
			label: "Name",
			newAccount: "New account",
			createButton: "Create account",
			cancelButton: "Cancel",
		},
		accountsList: {
			title: "Your accounts",
			description: "List of all your accounts",
			emptyAccountsList: "No account created."
		},
		profile: {
			title: "Profile",
			description: "General preferences from your account."
		},
		renameBankAccount: {
		  title: "Rename bank account",
			description: "Enter the new bank account",
			label: "Name",
			newName: "New name",
			saveButton: "Save"
		},
	},
	sidebar: {
		menuItems: {
			dashboard: "Dahsboard",
			transactions: "Transactions",
			accounts: "Accounts",
			noAccounts: 'No account',
			profile: "Profile",
		},
		dropdownProfile: {
			button: "Profile",
			contact: "Contact",
			onboarding: "Onboarding",
			settings: "Settings",
			demoTitle: 'Demo mode',
			demoSubTitleActive: 'Demo data activated',
			demoSubTitleInactive: 'Turn on to explore with demo data',
			logout: "Logout",
		},
		logout: {
			title: 'Logout Confirmation',
			description: 'Are you sure you want to log out of the application? All active sessions will be closed and you will need to log back in to access your information.',
			success: 'Successfully logout',
		},
		mobileMenu: {
			modalAction: {
				title: 'Create action',
				description: 'You can create a new transaction or a new account.'
			}
		},
	},
	categoriesList: {
		pets: "Pets",
		shopping: "Shopping",
		food: "Food & Restaurants",
		insurance: "Insurance & Savings",
		credits: "Credits",
		childs: "Childs",
		account: "Savings & Investments",
		taxes: "Taxes, Duties & Fees",
		home: "Housing & Charges",
		recreation: "Leisure & Holidays",
		withdrawals: "Withdrawals",
		health: "Health",
		transportation: "Transportation",
		work: "Work & Studies",
	},
	newDashboard: {
		accountsDropdown: {
			default: 'All',
			button: "Switch account",
			title: "Accounts",
		},
		greetings: {
			sayHi: "Hello {name},",
			description: "Here's what's happening today",
			btnAccount: 'Add new account',
			btn: 'New Transaction',
			btnTooltipContent: "You need to create an account before to add an operation",
			btnTooltipTransactionsDemo: 'Disable demo mode to create transactions',
			btnTooltipAccountDemo: 'Disable demo mode to create accounts',
		},
		card: {
			noLabel: 'No label',
			demo: {
				errorFailed: 'Failed to retrieve demo data, please try again or contact us',
			},
			amount: {
				title: "Net amount",
				defaultPlaceholder: "All",
				tooltipContent: "<strong>Net amount</strong> based on the date you selected for the chosen account(s).",
				loader: "Please hang on while we're fetching your datas",
				missingDatas: 'Create at least one account, make two transactions, and add or change the date range to display the chart',
				missingDatasDemo: 'Turn off demo mode to start creating accounts, transactions',
				chartCaption: 'Transactions from {startDate} to {endDate}',
				btnAddAccount: 'Add an account',
				btnAddTransaction: 'Add a transaction',
				emptyDatas: "No data",
				footerTitle: "Click on chart to get more informations",
			},
			traffic: {
				income: {
					name: "Income",
					description: 'Transactions from {startDate} to {endDate}',
					lastMonth: "vs last month",
					tooltipContent: "<strong>Credited amounts</strong> based on the date you selected for the chosen account(s)."
				},
				spending: {
					name: "Spending",
					description: 'Transactions from {startDate} to {endDate}',
					lastMonth: "vs last month",
					tooltipContent: "<strong>Debited amounts</strong> according to the date you have chosen for the selected account(s)."
				},
			},
			transactions: {
				title: "Transactions",
				description: "Your last five transactions",
				tooltipContent: "<strong>Last five transactions</strong> according to the date you have chosen for the selected account(s).",
				seeMore: "View more transactions",
				labels: {
					label: "LABEL",
					category: "CATEGORY",
					amount: "AMOUNT",
				},
			},
			categories: {
				title: "Catégories",
				description: "Your categories data about all your combined accounts.",
				tooltipContent: "<strong>Percentages of the categories</strong> according to the date you have chosen for the selected account(s).",
				labels: {
					category: "CATEGORY",
					percentage: "% OF OPERATIONS",
					amount: "AMOUNT",
				},
			},
		}
	},
	dashboard: {
		empty: {
			title: "Start create account",
			description: "It's empty here.. Start by create an bank account",
		},
		menu: {
			left: {
				firstLink: "Add Permanent",
				secondLink: "Add account",
			},
			right: {
				thirdLink: "Settings",
				fourthLink: "Logout",
				onboarding: "Start onboarding",
			},
			modalLogOut: {
				message: "Are you sure you want to log out ?",
				btnCancel: "Cancel",
				btnConfirm: "Confirm",
			},
		},
		cardHeader: {
			title: "Total account",
		},
		card: {
			seeMore: "See more",
			btnDelete: "Delete account",
			titleModalDeleteAccount:
				"Are you sure you want to delete <strong>{account}</strong>",
			tooltip: {
				bookmarked: "Bookmark this account",
			},
		},
		tabs: {
			emptyBookmarked: "Bookmarked an account to see it here",
			emptyOthers: "No account",
			emptySearch: "Write account name in the searchbar to see it here",
		},
	},
	settings: {
		title: "Settings",
		subTitle: "Manage your preferences",
		tabs: ["Profile", "Notifications", "Manage access and devices"],
		dangerousZone: "Dangerous Zone",
		notificationsTitle: 'Email Notifications',
		sessionsListTitle: 'Manage sessions',
		sessionsColumnsTableHeader: ['Browser and devices', 'Sessions', 'Location', 'Ip'],
		sessionsAlertDialogTitle: 'Delete session',
		sessionAlertDescription: 'Are you sure to delete this session ?',
		sessionAlertDescriptionCurrentSession: 'This is your current session, if you delete it you will be logged out.',
		sessionAlertBtns: ['Cancel', 'Delete'],
		sessionListSuccess: 'Session deleted',
		notifications: [
			{ title: 'Communication Emails', description: 'Receive emails about your account activity' },
			{ title: 'Security emails', description: 'Receive emails about your account activity and security.' },
		],
		form: {
			btn: 'Update',
			success: 'Your data has been correctly updated',
			error: "An error occurred while updating your data. Please try again.",
			userError: "An error occurred regarding your profile. Please try again later",
			updateUserError: "An error occurred during the modification, please try again later.",
			mail: {
				label: "Mail address",
				placeholder: 'Enter your mail',
				description: 'The email address used to authenticate you',
				errorFormat: "The format of the mail address is not correct",
			},
			name: {
				label: 'Name',
				description: 'This is your public display name.',
				placeholder: 'Enter your name',
			},
			currency: {
				label: "Convert to",
			},
			category: {
				label: "Create or delete your categories",
			},
		},
		password: {
			title: "Change password",
			form: {
				oldPassword: {
					label: "Old password",
				},
				newPassword: {
					label: "New Password",
				},
				confirmNewPassword: {
					label: "Confirm new password",
				},
				btn: {
					update: "Update password",
				},
			},
		},
		deleteAccount: {
			title: "Delete account",
			btnDelete: "Delete",
			description: "Once the account is deleted, it is no longer possible to go back. Please be sure of this.",
			drawer: {
				title: "Delete account",
				description: "Your account is about to be deleted. Are you sure you want to do this ?",
				btnCancel: "Cancel",
				btnConfirm: "Confirm",
				confirmToast: "Your account has been successfully deleted.",
			},
		},
	},
	contact: {
		title: "Contact",
		subTitle: "Tell us if you encounter some issues or any recommendations",
		form: {
			subject: {
				label: "Select a subject",
				types: [
					"Customer Support",
					"Technical Support",
					"Feedback or Suggestions",
					"Partnership or Collaboration",
				],
			},
			message: {
				label: "Write your message",
			},
			errors: {
				notEmpty: "Cannot be empty",
				apiError: "Error occured, please retry or wait some time.",
			},
			success: {
				apiSuccess: "Your mail has been correctly send.",
			},
		},
	},
  legal_confidentiality: {
    title: "Privacy Policy",
    link: "https://www.ticketsapp.money/en/legal-confidentiality"
  },
	legal_conditions: {
    title: "Terms and Conditions",
    link: "https://www.ticketsapp.money/en/legal-conditions"
  },
  legal_mentions: {
    title: "Legal Mentions",
    link: "https://www.ticketsapp.money/en/legal-mentions"
  },
	modalAccount: {
		title: "Create new bank account",
		form: {
			name: {
				label: "Account name",
				error: "Please fill in the account name",
				errorLength: "Account name must not exceed 25 characters",
				errorAccountNameLength: "The account name must contain at least 1 character",
			},
			amount: {
				label: "Init sold",
				error: "Please enter a balance greater than 0",
				errorType: "Please enter a number",
			},
			btnSubmit: "Confirm",
			onSuccess: '{name} successfully created',
			onError: 'An account with the same name already exists.'
		},
	},
	createOp: {
		placeholderFilter: 'Filter by label',
		sheet: {
			titleAdd: 'Create new transaction',
			subTitle: 'The transactions are simulated and do not affect your real bank accounts. They, along with the accounts, allow you to simulate and better manage your finances.',
			titleUpdate: 'Update new transaction',
			rowsEmpty: 'No results, try to add some transactions',
		},
		form: {
			columns: {
				mandatory: 'Required Informations',
				optionals: 'Optionals Informations',
				title: {
					label: 'Label',
					bankAccount: 'Bank Account',
					amount: 'Amount',
					categories: 'Category',
					date: 'Date',
				},
				action: {
					dialogTitle: 'Delete this transaction',
					dialogBody: 'Are you sur to delete this transaction ? It will be permanent',
					edit: 'Edit',
				},
				sortable: {
					asc: 'Asc',
					desc: 'Desc',
				},
			},
			rows: {
				bankAccount: {
					title: 'Bank Account',
					placeholder: 'Select bank account',
				},
				amount: {
					title: 'Amount',
					description: 'Amount of your operation',
				},
				categories: {
					title: 'Categories',
					placeholder: 'Open categories list',
				},
				date: {
					title: 'Transaction Date',
					placeholder: 'Pick a date',
				},
				label: {
					title: 'Label',
					placeholder: 'Transaction label',
					error: "Please fill in a label",
					errorLength: 'The label must not exceed 25 characters',
				},
				type: {
					title: 'Select Operation type',
					error: 'Please select an transaction type',
					errorType: 'Transaction type can only be debit or credit',
					value: ['Debit', 'Credit'],
				},
			},
			btn: ['Create', 'Update'],
			onSuccess: 'Transaction created',
			onUpdate: 'Transaction updated',
			onDelete: 'Transaction deleted',
		},
	},
	table: {
		modalDeleteTitle: "Are you sure to delete {adjective}",
		noMoreDataToFetched: "No more data to fetched",
	},
	onboarding: {
		title: "Welcome !",
		description: "Tickets helps you manage your finances efficiently. <br/> You can create accounts by clicking the <strong>'+ Add Account'</strong> button and record bank transactions by clicking the <strong>'+ Add Transaction'</strong> button to simulate your expenses and savings, <strong>without impacting your personal accounts</strong>.",
		btnBegin: "Start",
		btnPrev: "Previous",
		demoTitle: 'Demo mode activated',
		demoContent: "As a new user, we automatically enable demo mode to allow you to explore with sample data. You can disable/enable it whenever you want.",
		btnNext: "Next",
		btnFinish: "Finish",
		operationsList: {
			title: "Operations List",
			description:
				'All your operations are listed here, you can edit them by clicking on the "edit" text or delete one or many operations by selected them by clicking on the thick boxe.',
		},
		searchAccount: {
			title: "Search account",
			description: "Start writing account name to search a specific account.",
		},
		filterAccount: {
			title: "Filter accounts",
			description:
				"You can filter your accounts by bookmarked, search or others",
		},
		congrats: {
			title: "All done",
			description:
				'You can if you wish restart the onboarding process by clicking on the "Start onboarding" button, you can now use the ticket application enjoy.',
		},
	},
	transactions: {
		title: 'Transactions',
		subTitle: 'List all the transactions from every bank accounts',
	},
	accountTransactions: {
		title: 'Transactions',
		subTitle: 'List all the transactions for your {name} account',
	},
	transactionsMetadata: {
		bankAccountTotal: 'Total',
		total: 'Total Transactions',
		income: 'Incomes',
		spending: 'Spending',
	},
	updateAccount: {
	  content: "The name of the bank account has been changed."
	}
}
